import React, {useState} from 'react'
import 'bootstrap/dist/css/bootstrap.css'
import Modal from 'react-bootstrap/Modal'
import Button from 'react-bootstrap/Button'

const Question = ({show, setShow, text = '', mesagge = '', buttons = []}) => {
  const click = item => {
    item.click()
    setShow([])
  }
  return (
    <Modal show={show} onHide={() => setShow([])}>
      <Modal.Header closeButton>
        <Modal.Title>{text}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>{mesagge}</p>
      </Modal.Body>
      <Modal.Footer>
        {buttons.map((item, inx) => (
          <Button variant="primary" onClick={() => click(item)} key={inx}>
            {item.title}
          </Button>
        ))}
      </Modal.Footer>
    </Modal>
  )
}

export default Question
